export default __webpack_public_path__ + "static/media/v2_hodnota_2.cc31ba53.svg";